var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.companies),function(company){return _c('b-col',{key:company.id,staticClass:"mb-4",attrs:{"cols":"12","md":"3","align":"center"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":company.image}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }